import { Observable, Subject } from 'rxjs';

export class SocketEvent<T> {
    public readonly name: string;
    public readonly subject: Subject<T>;

    get listener(): (event) => void {
        return event => this.subject.next(event);
    }

    get observable(): Observable<T> {
        return this.subject.asObservable();
    }

    constructor(name: string, subject: Subject<T>) {
        this.name = name;
        this.subject = subject;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/web-socket/socket-event.ts